import classNames from 'classnames'
import { ForwardedRef, forwardRef } from 'react'

import { IFlexProps } from './models/IFlexProps'

import styles from './Flex.module.scss'

export const Flex = forwardRef(
  (
    {
      className,
      children,
      display = 'flex',
      flexDirection,
      flexWrap = 'nowrap',
      justifyContent,
      alignItems,
      alignContent,
      gap = 'sm',
      gapX,
      gapY,
      width,
      height,
      flexGrow,
      flexShrink,
      flexBasis,
      onClick,
      __testId,
    }: IFlexProps,
    ref: ForwardedRef<HTMLDivElement>
  ) => {
    const rootStyles = {
      width,
      height,
      flexGrow,
      flexShrink,
      flexBasis,
    }

    return (
      <div
        ref={ref}
        onClick={onClick}
        className={classNames(
          styles.root,
          {
            [styles[`display--${display}`]]: display,
            [styles[`flexDirection--${flexDirection}`]]: flexDirection,
            [styles[`flexWrap--${flexWrap}`]]: flexWrap,
            [styles[`justifyContent--${justifyContent}`]]: justifyContent,
            [styles[`alignItems--${alignItems}`]]: alignItems,
            [styles[`alignContent--${alignContent}`]]: alignContent,
            [styles[`gapX--${gapX}`]]: gapX,
            [styles[`gapY--${gapY}`]]: gapY,
            [styles[`gap--${gap}`]]: gap,
          },
          className || ''
        )}
        style={rootStyles || undefined}
        data-testid={__testId || 'flex-root'}
      >
        {children}
      </div>
    )
  }
)
